
// 接口域名
const PREFIX = 'https://certificate.posedu.com.cn/api/';
// const PREFIX = 'http://192.168.2.68:8066/api/';
// const PREFIX = 'http://192.168.2.126:8066/api/';
// const PREFIX = 'http://localhost:8066/api/';
// 定义接口名称
const api = {
	'updatacode': PREFIX + 'user/getUpdatePhoneSmsCode/',//验证码
	//证书管理接口
	'datacord': PREFIX + 'certificate/selectCertificateList',
	'getTemplateList': PREFIX + 'certificate/getTemplateList',
	'delCertificate': PREFIX + 'certificate/delCertificate/',
	'matchImportCertificate': PREFIX + 'certificate/matchImportCertificate',
	'getProgress': PREFIX + 'certificate/getProgress',
	'getCertificateInfo': PREFIX + 'certificate/getCertificateInfo/',
	'setPrintCertificate': PREFIX + 'certificate/setPrintCertificate',
	'getCertificateZip': PREFIX + 'certificate/getCertificateZip'+'?ids='+'5',

	'getSubject': PREFIX + 'certificate/getSubject',

	//模板管理接口
	'selectTemplateList': PREFIX + 'certificate/selectTemplateList',
	'addTemplate': PREFIX + 'certificate/addTemplate',
	'delTemplate': PREFIX + 'certificate/delTemplate/',
}

export default api;
export const e = PREFIX;


// WEBPACK FOOTER //
// ./src/router/api.js



// WEBPACK FOOTER //
// ./src/router/api.js